import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  jobsRecommendedPerson: [],
  cachedJobsRecommendedPerson: [],
  recommendationsByJob: [],
  cachedRecommendationsByJob: [],
  jobsIWasIndicatedPerson: [],
  cachedJobsIWasIndicatedPerson: [],
  indicationsIReceivedByJob: [],
  cachedIndicationsIReceivedByJob: [],
  indicationsByJobId: [],
  cachedIndicationsByJobId: [],
};

export default {
  actions,
  getters,
  mutations,
  state,
};
